import './social_content_view.js.coffee'
Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.WebchatContentView extends Monitoring.Views.SocialContents.SocialContentView

  render: ->
    super
    @$el.addClass("inbox #{@model.type()}")
    this
